export enum LegacyOpenQuestionKind {
  String = 'string',
  Text = 'text',
  Boolean = 'boolean',
  SingleChoice = 'single_choice',
  MultiChoice = 'multi_choice',
  File = 'file',
  Vidoe = 'video',
}
